/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import DateTime from 'react-datetime';
import Holon from '../Buttons/holon';
import Dropdown from '../Buttons/dropdown';
import { formatDateHyphen } from '../../utils/dateHelpers';
import { allows } from '../../utils/authorization';

class DetailHeader extends React.Component {
  handleDeploymentDelete = () => {
    this.props.handleDelete(this.props.deployment.id);
    this.props.onClose();
  };

  handleDeploymentRestore = () => {
    this.props.handleRestore(this.props.deployment.id);
    this.props.onClose();
  };

  handleDateChange = newDate => {
    const payload = { deployment_date: formatDateHyphen(newDate) };
    this.props.handleUpdate(payload);
  };

  render() {
    const { deployment, stories, onClose } = this.props;
    const blocked = !!stories.filter(story => story.blocked).length;
    const allowEdit = allows('update', deployment);
    const allowDelete = allows('destroy', deployment);

    return (
      <div>
        <div className="col-sm-1">
          <Dropdown
            handleDelete={this.handleDeploymentDelete}
            handleRestore={this.handleDeploymentRestore}
            allowEdit={allowEdit}
            allowDelete={allowDelete}
            allowRestore
            deleted={deployment.deleted_at}
          />
        </div>
        <div className="col-sm-4">
          <div className="col-sm-4">
            <strong className={`modal-title ${blocked ? 'red' : ''}`}>
              Deployment {deployment.id}
            </strong>
          </div>
          <div className="col-sm-7 col-sm-offset-1 dates">
            <div className="col-sm-6">Deployment Date:&nbsp;</div>
            <DateTime
              value={formatDateHyphen(deployment.deployment_date)}
              dateFormat="YYYY/MM/DD"
              timeFormat={false}
              onChange={date => this.handleDateChange(date)}
              className="col-sm-6"
              closeOnSelect
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="center">
            <Holon />
          </div>
        </div>
        <div className="col-sm-5 form-inline">
          <div className="col-sm-1 col-sm-offset-11 detail-close">
            <button type="button" className="btn-close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DetailHeader.propTypes = {
  handleUpdate: PropTypes.func,
  handleRemove: PropTypes.func,
  handleDelete: PropTypes.func,
  onClose: PropTypes.func,
  deployment: PropTypes.object,
  stories: PropTypes.array,
  cadence: PropTypes.number,
  options: PropTypes.object
};

export default DetailHeader;
